import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { routeConfiguration } from '../../../../index';
import { createResourceLocatorString } from '../../../../util/routes';
import RegionCard from '../../../BasicUI/Cards/RegionCard';
import { withBaseComponent } from '../../hoc/withBaseComponent';

const destinations = [
  {
    title: 'Deutschland',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x427/0048abd92c/germany.webp',
      alt: 'Splash of Germany Bayern Castle',
      title: 'Splash of Germany Bayern Castle',
    },
    slug: 'zeltplatz',
    rest: 'deutschland',
  },
  {
    title: 'Frankreich',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x427/ecb52b81d4/france.webp',
      alt: 'Lavendel Wiesen in Frankreich',
      title: 'Lavendel Wiesen in Frankreich',
    },
    slug: 'zeltplatz',
    rest: 'frankreich',
  },
  {
    title: 'Italien',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x800/1dd75fccb9/italy.webp',
      alt: 'Italy Coast',
      title: 'Italy Coast',
    },
    slug: 'zeltplatz',
    rest: 'italien',
  },
  {
    title: 'Schweiz',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x427/15fff8765d/swiss.webp',
      alt: 'Mountains of swiss',
      title: 'Mountains of swiss',
    },
    slug: 'zeltplatz',
    rest: 'schweiz',
  },
  {
    title: 'Österreich',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x480/dd611c8121/austria.webp',
      alt: 'Austra view of mountains',
      title: 'Austra view of mountains',
    },
    slug: 'zeltplatz',
    rest: 'oesterreich',
  },
  {
    title: 'Spanien',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x427/36bbe5022d/spain.webp',
      alt: 'Coast of Spain',
      title: 'Coast of Spain',
    },
    slug: 'zeltplatz',
    rest: 'spanien',
  },
  {
    title: 'Dänemark',
    subtitle: 'Zeltplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/2400x1603/f963cd1602/wohnmobilstellplatz-danemark.webp',
      alt: 'Coast of Denmark',
      title: 'Coast of Denmark',
    },
    slug: 'zeltplatz',
    rest: 'daenemark',
  },
  {
    title: 'Norwegen',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/1000x500/b37979cf84/45.webp',
      alt: 'Coast of Norway',
      title: 'Coast of Norway',
    },
    slug: 'zeltplatz',
    rest: 'norwegen',
  },
  {
    title: 'Niederlande',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/1000x667/9b2056e1bc/14159-_1_.webp',
      alt: 'Coast of Netherlands',
      title: 'Coast of Netherlands',
    },
    slug: 'zeltplatz',
    rest: 'niederlande',
  },
  // Add more destinations as needed
];

const StoryblokCountriesTentPreset = () => {
  const intl = useIntl();

  return (
    <Container
      maxWidth="xl"
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 6 }}
    >
      <Typography component="h2" sx={{ mb: 6 }} variant="h3">
        <FormattedMessage id="SectionCountries.tent.header" />
      </Typography>
      <Grid container justifyContent="center" spacing={4}>
        {destinations.map((destination, index) => {
          const link = createResourceLocatorString(
            'StoryblokPage',
            routeConfiguration(),
            { slug: destination.slug, rest: destination.rest },
            {},
            intl.locale,
          );

          return (
            <Grid key={index} size={{ lg: 4, md: 6, xs: 12 }}>
              <RegionCard
                image={destination.image}
                link={link}
                subtitle={destination.subtitle}
                title={destination.title}
              />
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default withBaseComponent(StoryblokCountriesTentPreset);
